import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Course } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface CurrentCourseState {
  currCourse: Course;
  index: number;
}

// Define the initial state using that type
const initialState: CurrentCourseState = {
  currCourse: {
    addedOn: null,
    description: "",
    formationId: 0,
    id: 0,
    image: "",
    lastModifiedOn: null,
    ressourceType: "",
    ressource: "",
    title: "",
  },
  index: 0,
};

export const currentCourseSlice = createSlice({
  name: "currentCourse",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrentCourse: (state, action: PayloadAction<Course>) => {
      state.currCourse = action.payload;
    },
    setIndex: (state, action: PayloadAction<number>) => {
      state.index = action.payload;
    },
  },
});

export const { setCurrentCourse, setIndex } = currentCourseSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectCurrentCourse = (state: RootState) => state.currentCourse;
export default currentCourseSlice.reducer;
